module.exports = __webpack_public_path__ + "static/media/transactions.1cf1db4d.png";